export default __webpack_public_path__ + "static/media/J_Jornal.c9346567.svg";